// extracted by mini-css-extract-plugin
module.exports = {"hidden":"resultTab_hidden__Vzz_D","textEmphasis":"resultTab_textEmphasis__vTPyO","btnArea":"resultTab_btnArea__fVyby","btn":"resultTab_btn__zrAgX","on":"resultTab_on___qo7l"};